import * as React from 'react';

import { cn } from '@/lib/utils';

interface TaskSectionProps {
  title?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
  compact?: boolean;
  action?: React.ReactNode;
}

export const TaskSection: React.FC<TaskSectionProps> = ({
  title,
  children,
  className,
  noPadding = false,
  compact = false,
  action,
}) => {
  return (
    <div className={cn(!noPadding && (compact ? 'py-3' : 'py-4'), className)}>
      {title && (
        <div
          className={cn(
            'flex items-center justify-between',
            compact ? 'mb-2' : 'mb-3',
          )}
        >
          <h3 className="text-[10px] font-semibold text-slate-900 uppercase tracking-wider">
            {title}
          </h3>
          {action && <div>{action}</div>}
        </div>
      )}
      {children}
    </div>
  );
};
